import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyValuationService } from 'src/app/shared/services/property-valuation.service';

@Component({
  selector: 'app-view-property',
  templateUrl: './view-property.component.html',
  styleUrls: ['./view-property.component.css']
})
export class ViewPropertyComponent implements OnInit {

  public pageName: string = "view property";

  displayReg: boolean;
  displayLogin: boolean;
  recievedParams: any;

  user: any;
  property: any;
  isVisible: boolean = false;
  isLoading: boolean;
  successMessage: string;


  constructor(private router: Router, private route: ActivatedRoute, private valuationService: PropertyValuationService) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params) => {
      var stringParams = params.queryParams;
      this.recievedParams = JSON.parse(stringParams);
      console.log('recievedParams: ', this.recievedParams);

      this.property = this.recievedParams.source;
      // this.user = this.recievedParams.user;

      // if (this.user.attributes.email === this.property._source.owner) {
      //   this.isVisible = true;
      // } else {
      //   this.isVisible = false;
      // }

    });

  }

  onEvaluate(property: any) {
    console.log("Property: ", property);

    const propValuationObj = {
      "propertyId": property._id,
      "description": property._source.description,
      "propertyName": property._source.name,
      "agencyName": "Ganizani Consulting Services"
    }

    this.isLoading = true;
    this.valuationService.requestPropertyEvaluation(propValuationObj).subscribe((data) => {

      console.log(data);

      const valuationObj = {
        propName: property._source.name
      }

      this.sendValuationNotification(valuationObj);

    }, (error) => {
      this.isLoading = false;
      console.log("Error requesting Property Evaluation", error);
    });
  }

  sendValuationNotification(propertyObject: any){
    
    this.valuationService.sendValuationNotification(propertyObject).subscribe((data) => {
      this.isLoading = false;
      this.successMessage = "You have successfully submited a request to Evaluate your property, you can check the progress of your evaluation under Evaluations page";
      console.log("Valuation: ", data);
    }, (error) => {
      this.isLoading = false;
      console.log("Valuation Notification Error: ", error);
    })
  }


  viewSignUp() {
    this.displayReg = true;
  }

  viewSignIn() {
    this.displayLogin = true;
  }

  closeForms($event) {
    this.displayLogin = false;
    this.displayReg = false;
  }

}
